import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { Icon } from "@iconify/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const FormGenderSelect = ({
  label = "Gender",
  value,
  onChange,
  labelColor="var(--app-text-muted)",
  errors,
  required = false,
  disabled = false,
}) => {
  const fieldError =
    typeof errors === "string"
      ? { message: errors }
      : errors?.message
        ? errors
        : null;
  const DropdownIcon = (props) => (
    <Icon icon="eva:arrow-ios-downward-fill" {...props} />
  );
  return (
    <Box>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: labelColor,
          mb: "6px",
          fontFamily: "Figtree",
        }}
      >
        {label}
        {required && <span style={{ color: "#d32f2f" }}> *</span>}
      </Typography>

      <FormControl fullWidth error={!!fieldError}>
        <Select
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          displayEmpty
          variant="filled"
          disableUnderline
          IconComponent={KeyboardArrowDownIcon}
          sx={{
            height: "48px",
            borderRadius: "8px",
            backgroundColor: "var(--app-surface)",
            border: "1px solid var(--app-border)",
            px: "12px",
            fontFamily: "Figtree",

            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              height: "100%",
              padding: 0,
              color: value ? "var(--app-text)" : "var(--app-text-muted)",
            },

            "& .MuiSelect-icon": {
              color: "var(--app-text-muted)",
              right: "12px",
            },
            // REMOVE HOVER
            "&:hover": {
              backgroundColor: "var(--app-surface)",
            },

            // REMOVE FOCUS COLOR
            "&.Mui-focused": {
              backgroundColor: "var(--app-surface)",
            },

            // VERY IMPORTANT (Filled variant focus fix)
            "& .MuiFilledInput-root.Mui-focused": {
              backgroundColor: "#FFFFFF !important",
            },

            "& .MuiFilledInput-root:hover": {
              backgroundColor: "#FFFFFF !important",
            },

            "&.Mui-disabled": {
              backgroundColor: "var(--app-surface-2)",
              color: "var(--app-text-muted)",
            },
          }}
        >
          <MenuItem value="" disabled>
            Select Gender
          </MenuItem>
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Others">Others</MenuItem>
        </Select>

        {/* Error Message */}
        {fieldError?.message && (
          <Typography
            sx={{
              color: "#d32f2f",
              fontSize: "12px",
              mt: "4px",
              fontFamily: "Figtree",
            }}
          >
            {fieldError.message}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};

export default FormGenderSelect;
